'use strict';
module.exports = require('./TieredMenu.vue');